import $ from 'axios'
const api = {
    apiHost: '/views/tenement/apis',
    api: function (url, param) {
        var urlParam = new URLSearchParams();
        for (var p in param) {
            urlParam.append(p, param[p]);
        }
        return $.post([this.apiHost, url].join('/'), urlParam).then(function (result) {
            return result.data;
        }).catch(function () {
            alert('数据出错!');
            console.log(arguments);
        });
    },
    /* 
    列表
    参数：
    {
        type: 类型id(0默认 1新房 2二手房 3租房 4商铺 5商业地产), 
        search: '搜索', 
        page: 当前页, 
        size: 每页数, 
        district: 区域
    }
    */
    list: function (param) {
        return this.api('list.ashx', param);
    },
    //详情，参数：id
    detail: function (id) {
        return this.api('detail.ashx', { id });
    },

    //分享
    share: function () {
        return this.api('jsApis.ashx', {});
    }
}
if (process.env.NODE_ENV != 'production') {
    api.apiHost = 'http://localhost:6127' + api.apiHost;
}
export default api;